import React from "react";
import UserProfile from "../Components/Users/UserProfile";

const UserProfilePage = () => {
  return <UserProfile />;
};

export default UserProfilePage;
